var map = {
	"./de/btn-detail.png": "uh4X",
	"./en/btn-detail.png": "7O3E",
	"./es/btn-detail.png": "FM/J",
	"./fr/btn-detail.png": "R7uj",
	"./ja/btn-detail.png": "lMw1",
	"./ko/btn-detail.png": "y0/z",
	"./pt/btn-detail.png": "H8zN",
	"./ru/btn-detail.png": "MpaQ",
	"./th/btn-detail.png": "PqUZ",
	"./zh-Hant/btn-detail.png": "U5KV"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "jegL";